import axios from 'axios'

export default {
  data() {
    return {
      listagemTipoEnvioSir2Monit: [],
      listagemSituacaoSir: [],
      listagemTipoSir2Monit: [],
      listagemSubTipoSir2Monit: []
    }
  },
  methods: {
    listarTipoSir2Monit: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlSir2 + 'TipoSir2Monit/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listagemTipoSir2Monit = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarSubTipoSir2Monit: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(this.baseUrlSir2 + 'SubTipoSir2Monit/Listar', this.dadosLoginSession.fccTokenHeaders)
          .then(response => {
            resolve(response.data)
            this.listagemSubTipoSir2Monit = response.data
            this.carregaTexto()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    listarTipoEnvioSir2Monit: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlSir2 + 'TipoEnvioSir2Monit/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listagemTipoEnvioSir2Monit = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarSituacaoSir: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlSir2 + 'SituacaoSir2Monit/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listagemSituacaoSir = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
